(function(Drupal, $, once){
    Drupal.behaviors.mo34 = {
        attach() {
            $(once('mo34', 'body')).first().each(function(){
                var expandClass = 'MO34__expand';
                var contentClass = 'MO34__content';
                var selectedClass = 'MO34--selected';
                var collapsedClass = 'MO34--collapsed';
                var $mo34 = $('.MO34');

                $mo34.each(function(){
                    var $component = $(this);
                    var $content = $component.find('.' + contentClass);
                    var $expandLink = $component.find('.MO34__header__title');
                    var $expandButton = $component.find('.' + expandClass);
                    var $contentWrap = $component.find('.MO34__content');

                    $expandButton.click(function(e) {
                        openActiveCard(e);
                    });

                    $expandLink.click(function(e) {
                        openActiveCard(e);
                    });

                    function openActiveCard(e){
                        var isCollapsed = $component.hasClass(collapsedClass);

                        $content.slideToggle(250);
                        $component.toggleClass(collapsedClass);

                        // Accessibility expandable section.
                        if(!isCollapsed) {
                            $expandButton.attr('aria-expanded','false');
                            $expandLink.attr('aria-expanded','false');
                            $contentWrap.attr('aria-hidden','true');
                        } else {
                            $expandButton.attr('aria-expanded','true');
                            $expandLink.attr('aria-expanded','true');
                            $contentWrap.attr('aria-hidden','false');
                        }

                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                });

                $.fn.mo34Collapse = function(){
                    this.each(function(){
                        var $component = $(this);
                        var $content = $component.find('.' + contentClass);
                        var isCollapsed = $component.hasClass(collapsedClass);

                        if (!isCollapsed) {
                            $content.slideUp(250);
                            $component.addClass(collapsedClass);
                        }
                    });
                    return $(this);
                };

                $.fn.mo34Select = function(){
                    this.each(function(){
                        $(this).addClass(selectedClass);
                    });
                    return $(this);
                };

                $.fn.mo34Unselect = function(){
                    this.each(function(){
                        $(this).removeClass(selectedClass);
                    });
                    return $(this);
                };

                $.fn.mo34IsSelected = function(){
                    return $(this).first().hasClass(selectedClass);
                };
            });
        }
    };
})(Drupal, jQuery, once);
